import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

/**
 * Serviço de Formulários
 * Gerencia todas as operações de formulários no backend
 */
const formulariosService = {

    // ==================== FORMULÁRIOS ====================

    /**
     * Listar todos os formulários de um cliente
     */
    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/formularios`, { params });
        return response.data;
    },

    /**
     * Buscar formulário por ID
     */
    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/${id}`);
        return response.data;
    },

    /**
     * Criar rascunho de formulário (draft)
     * Usado quando o usuário clica em "Novo Formulário"
     */
    criarDraft: async (clienteId, userId) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/formularios/draft`, { userId });
        return response.data;
    },

    /**
     * Criar novo formulário
     */
    criar: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/formularios/criar`, data);
        return response.data;
    },

    /**
     * Editar formulário existente
     */
    editar: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/formularios/${id}/editar`, data);
        return response.data;
    },

    /**
     * Deletar formulário (soft delete)
     */
    deletar: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/formularios/${id}/deletar`);
        return response.data;
    },

    /**
     * Publicar ou despublicar formulário
     */
    togglePublicar: async (id, isPublished) => {
        const response = await axiosInstance.put(`${API_BASE}/formularios/${id}/publicar`, { isPublished });
        return response.data;
    },

    /**
     * Duplicar formulário
     */
    duplicar: async (id, userId) => {
        const response = await axiosInstance.post(`${API_BASE}/formularios/${id}/duplicar`, { userId });
        return response.data;
    },

    // ==================== RESPOSTAS ====================

    /**
     * Buscar formulário público (para responder)
     */
    buscarPublico: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/${id}/publico`);
        return response.data;
    },

    /**
     * Submeter resposta do formulário
     */
    responder: async (id, data) => {
        const response = await axiosInstance.post(`${API_BASE}/formularios/${id}/responder`, data);
        return response.data;
    },

    /**
     * Listar respostas de um formulário
     */
    listarRespostas: async (formularioId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/${formularioId}/respostas`, { params });
        return response.data;
    },

    /**
     * Buscar valores distintos para filtros da planilha
     */
    filtrosRespostas: async (formularioId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/${formularioId}/respostas/filtros`, { params });
        return response.data;
    },

    /**
     * Buscar resposta específica
     */
    buscarResposta: async (respostaId) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/respostas/${respostaId}`);
        return response.data;
    },

    /**
     * Buscar estatísticas do formulário
     */
    estatisticas: async (formularioId) => {
        const response = await axiosInstance.get(`${API_BASE}/formularios/${formularioId}/estatisticas`);
        return response.data;
    },

    /**
     * Upload de arquivo para pergunta de formulário
     */
    uploadArquivo: async (formPublicId, questionId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('questionId', questionId);
        const response = await axiosInstance.post(
            `${API_BASE}/formularios/${formPublicId}/upload`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    /**
     * Upload de logo do formulário
     */
    uploadLogo: async (formId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(
            `${API_BASE}/formularios/${formId}/upload-logo`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    /**
     * Remover logo do formulário
     */
    removerLogo: async (formId) => {
        const response = await axiosInstance.delete(`${API_BASE}/formularios/${formId}/remove-logo`);
        return response.data;
    }
};

export default formulariosService;
